import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { setLoading } from '../../redux/loading';
import { useDispatch } from 'react-redux';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Fab from '@mui/material/Fab';
import { makeStyles } from '@mui/styles';
import { contactUsPhone } from 'utils/consts';

const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    bottom: '76px',
    right: '36px',
    backgroundColor: '#34af23',
    '&:hover': {
      backgroundColor: '#34ad00',
    },
    color: 'white',
  },
}));

export default function DialogContact() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleOnClickWhats = () => {
    window.open(
      `https://api.whatsapp.com/send?phone=${contactUsPhone}&text=Fale%20j%C3%A1%20conosco%20e%20tire%20sua%20d%C3%BAvida%20sobre%20nosso%20sistema%20.`,
    );
  };
  return (
    <div>
      <Fab
        className={`${classes.fab}`}
        align="right"
        onClick={handleOnClickWhats}
      >
        <WhatsAppIcon fontSize="large" />
      </Fab>
    </div>
  );
}
